<!--  -->
<template>
  <div class="question" id="question">
    <div id="header" class="header fn-clear opacity">
      <div class="centerline">
        <a href class="logo fl">
          <img src="./../assets/images/footer_logo@2x.png" alt />
        </a>
        <div class="tab fr btn-group" v-show="menu==true">
          <router-link to="/home" class="btn">首页</router-link>
          <router-link to="/guide" class="btn">申请指南</router-link>
          <router-link to="/way" class="btn">管理办法</router-link>
          <router-link to="/question" class="btn sure">常见问题</router-link>
          <router-link to="/news" class="btn">新闻</router-link>
        </div>
        <a href="javascript:;" class="morebtn" @click="changemenu()">
          <img v-show="menu==false" src="./../assets/images/mobile/-e-nav_btn_menu@2x.png" alt />
          <img v-show="menu==true" src="./../assets/images/mobile/-e-nav_btn_close@2x.png" alt />
        </a>
      </div>
    </div>
    <div class="questionbox">
      <div class="tit">
        <p class="title">申报工作常见问题回答</p>
        <img class="titline" src="./../assets/images/-e-js_title_line@2x.png" alt />
      </div>
      <div class="contxt" v-for="(item,index) in list" >
        <p class="question">Q{{index+1}}：{{item.asked}}</p>
        <p
          class="answer"
        >A{{index+1}}：{{item.question}}</p>
      </div>
    </div>
    <div class="footer-info fn-clear">
      <div class="tabline fn-clear">
        <div class="fl logowarp">
                <div class="logo">
                  <img class="logo-site logoimg" src="./../assets/images/footer_logo@2x.png" />
                </div>
                <p class="mobile1">
                  <img class="icon" src="./../assets/images/-e-footer_icon_tell.png" /> 010-89738968
                </p>
                <p class="mobile">
                  <img class="icon" src="./../assets/images/-e-footer_icon_mail.png" /> fundamental@zhishifenzi.com
                </p>
                </div>
                <div class="fl link"  style="width:16%">
                  <p class="tit">相关链接</p>
                  <div class="btnlist fn-clear">
                    <p><router-link to="/home">首页</router-link></p>
                              <p style="margin-top: 10px;"><router-link to="/guide">申请指南</router-link></p>
                              <p style="margin-top: 10px;"><router-link to="/way">管理办法</router-link></p>
                              <p style="margin-top: 10px;"><router-link to="/question">常见问题</router-link></p>
                              <p style="margin-top: 10px;"><router-link to="/news">新闻</router-link></p>
                  </div>
                </div>
                <div class="fl etctxt">
                    <p class="tit">联系我们</p>
                  <p class="mobile">
                    <img src="./../assets/images/-e-footer_icon_tell.png" /> 010-89738968
                  </p>
                  <p class="mobile">
                    <img src="./../assets/images/-e-footer_icon_mail.png" /> fundamental@zhishifenzi.com
                  </p>
                </div>
                <div class="fr erweima">
                <img src="./../assets/images/erweima.png" sytle="width:120px;height:120px;"/>
                </div>
      </div>
      <div class="footertxt">
        <p class="copyright">Copyright © 1998 - 2020 ZhiShiFenZi. All Rights Reserved.</p>
        <p class="desctxt"><a href="http://www.51yuqian.cn/" class="desctxt" target="_blank">技术支持：榆钱（北京）科技有限公司</a></p>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {getFaqUrl} from "./../config/config.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
    menu: false,
    list:[],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    changemenu: function () {
      this.menu = !this.menu;
    },
    vediodemo() {
                this.$http({
                         method: "get",
                         url: getFaqUrl(),
                         params: {},
                       }).then(rem => {
                       this.list = rem.data.data;

                       });
             },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  this.vediodemo();
    var _this = this; //获取元素距离屏幕左边的距离
    var divLeft = document.body.clientWidth;
    console.log(divLeft);
    //获取网页可见区域宽度
    if (divLeft <= 980) {
      console.log(_this.menu);
      if (_this.menu == true) {
        _this.menu = false;
      } else {
        _this.menu = false;
      }
    } else {
      _this.menu = true;
      console.log(_this.menu);
    }
    /* 屏幕宽度变化 */
    window.onresize = function () {
      //获取元素距离屏幕左边的距离
      var divLeft = document.body.clientWidth;
      console.log(divLeft);
      //获取网页可见区域宽度
      if (divLeft <= 980) {
        console.log(_this.menu);
        if (_this.menu == true) {
          _this.menu = false;
        } else {
          _this.menu = false;
        }
      } else {
        _this.menu = true;
        console.log(_this.menu);
      }
    };
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
@r: 37.5rem;
//@import url(); 引入公共css类
#header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  margin: auto;
  height: 88px;
  z-index: 999;
  background: #fff;
  border-bottom: 1px solid #b38136;
  .centerline {
    max-width: 1200px;
    width: 100%;
    display: block;
    margin: auto;
  }

  .logo {
    width: 136px;
    height: 56px;
    display: inline-block;
    z-index: 999;
    img {
      margin-top: 16px;
      display: block;
      width: 100%;
    }
  }

  .tab {
    margin-right: 70px;
    z-index: 998;
    a {
      font-size: 16px;
      font-family: PingFang SC Medium, PingFang SC Medium-Medium;
      font-weight: 500;
      text-align: justifyLeft;
      color: #333;
      display: block;
      line-height: 88px;
      margin-right: 50px;
    }

    a.sure {
      color: #b38136;
    }

    a:hover {
      color: #b38136;
    }
  }

  .into {
    margin-top: 24px;
    width: 130px;
    height: 40px;
    line-height: 40px;
    background: linear-gradient(#ca9133 0%, #c8ac82 100%);
    color: #fff;
    text-align: center;
    display: inline-block;
    cursor: pointer;
  }
}

.questionbox {
  padding-top: 180px;
  padding-bottom: 80px;
  max-width: 1100px;
  width: 100%;
  margin: auto;
  > .tit {
    padding-bottom: 80px;
    .title {
      font-size: 32px;
      font-family: PingFang SC Semibold, PingFang SC Semibold-Semibold;
      font-weight: 600;
      text-align: justifyLeft;
      color: #1f1f1f;
      text-align: center;
    }

    .titline {
      width: 300px;
      display: block;
      margin: auto;
    }
  }
  .contxt {
    padding-bottom: 70px;
    .question {
      font-size: 18px;
      font-family: PingFang SC Medium, PingFang SC Medium-Medium;
      font-weight: 500;
      text-align: justifyLeft;
      color: #3d3a35;
      line-height: 32px;
      margin-bottom: 30px;
    }
    .answer {
      font-size: 16px;
      font-family: PingFang SC Regular, PingFang SC Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #747474;
      line-height: 32px;
    }
  }
}
/* 页脚 */
.footer-info {
  border-top: 1px solid #f5f5f5;
  width: 1230px;
  margin: auto;
  display: block;
  padding: 60px 0 42px 0;

  .tabline {
    > .fl {
      width: 33%;
    }

    .logo {
      img {
        display: block;
        width: 140px;
        height: 58px;
      }
    }

    .link {
      padding-left: 74px;
      box-sizing: border-box;

      .tit {
        font-size: 16px;
        font-family: PingFang SC Medium, PingFang SC Medium-Medium;
        font-weight: 500;
        text-align: justifyLeft;
        color: #b4812d;
        line-height: 16px;
      }

      .btnlist {
        margin-top: 30px;
        padding-bottom: 57px;

        a {
          font-size: 14px;
          font-family: PingFang SC Regular, PingFang SC Regular-Regular;
          font-weight: 400;
          text-align: justifyLeft;
          color: #3d3a35;
          line-height: 16px;
          margin-right: 20px;
        }
      }
    }

    .etctxt {
      .mobile {
        font-size: 20px;
        font-family: Arial Bold, Arial Bold-Bold;
        font-weight: 700;
        text-align: justifyLeft;
        color: #3d3a35;
        line-height: 16px;
        margin-left: 10px;
        margin-bottom: 25px;

        img {
          display: inline-block;
          height: 18px;
          margin-right: 9px;
        }
      }
    }
  }

  .copyright {
    font-size: 16px;
    font-family: PingFang SC Regular, PingFang SC Regular-Regular;
    font-weight: 400;
    text-align: justifyLeft;
    color: #747474;
    line-height: 32px;
    letter-spacing: 0px;
  }

  .footertxt {
    .copyright {
      font-size: 14px;
      font-family: PingFang SC Regular, PingFang SC Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #747474;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: center;
    }

    .desctxt {
      margin: 20px auto 0 auto;
      font-size: 14px;
      font-family: PingFang SC Regular, PingFang SC Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #747474;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: center;
    }
  }
}
@media (max-width: 960px) {
  #header {
    height: 100 / @r;
    overflow: auto;

    .morebtn {
      display: block;
      position: fixed;
      width: 32 / @r;
      height: 29 / @r;
      right: 30 / @r;
      top: 36 / @r;
      z-index: 999;

      img {
        display: block;
        width: 100%;
      }
    }

    .logo {
      position: relative;
      margin-left: 22 / @r;
      margin-top: 30 / @r;
      z-index: 2;
      height: 57 / @r;

      img {
        margin-top: 0;
        height: 100%;
        width: auto;
      }
    }

    .into {
      display: none;
    }

    .tab {
      position: fixed;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      opacity: 0.9;
      background: #000002;
      display: block;

      a:first-child {
        margin-top: 20vw;
      }

      a {
        display: block;
        text-align: center;
        margin-right: 0;
        color: #fff;
      }

      a.sure {
        color: #b38136;
      }
    }
  }
  /* 公共头部 */
  .questionbox {
    padding-top: 20vw;
    background: #fff;
    background-image: none;
    .tit {
      padding-bottom: 70 / @r;
      .title {
        font-size: 34 / @r;
        margin: 26 / @r 0;
        line-height: 40 / @r;
        .time {
          line-height: 40 / @r;
        }
      }
      .titline {
        width: 280 / @r;
      }
    }

    .contxt {
      padding: 0 30 / @r;
      .title {
        font-size: 28 / @r;
        margin: 30 / @r 0;
        .time {
          font-size: 24 / @r;
        }
      }
      .question {
        font-size: 28 / @r;
        padding-bottom: 26 / @r;
        margin-bottom: 0;
      }
      .answer {
        font-size: 28 / @r;
        line-height: 48 / @r;
        margin-bottom: 70 / @r;
      }
    }
  }
  /* 页脚 */
  .footer-info {
    width: 100%;
    border-top: 1px solid #f5f5f5;
    padding-bottom: 40 / @r;

    .tabline {
      padding-bottom: 40 / @r;
      padding: 0 30 / @r 40 / @r 30 / @r;

      .logo {

        img {
          width: 140 / @r;
          height: 58 / @r;
        }
      }

      > .fl {
        width: auto;
      }

      .etctxt {
        float: right;

        .mobile:not(:last-child) {
          margin-bottom: 25 / @r;
        }

        .mobile {
          white-space: nowrap;

          img {
            height: 24 / @r;
            margin-right: 12 / @r;
            display: inline-block;
          }

          font-size: 24 / @r;
          font-family: Arial Regular, Arial Regular-Regular;
          font-weight: 400;
          text-align: justifyLeft;
          color: #3d3a35;
          line-height: 24 / @r;
        }

        .mobile:last-child {
          margin-bottom: 0;
        }
      }
    }

    .footertxt {
      p {
        font-size: 20 / @r;
        font-family: PingFang SC Regular, PingFang SC Regular-Regular;
        font-weight: 400;
        text-align: justifyLeft;
        color: #aaaaaa;
        line-height: 20 / @r;
        letter-spacing: 0 / @r;
      }

      .copyright {
        font-size: 20 / @r;
      }

      .desctxt {
        margin: 20 / @r auto 0 auto;
        font-size: 20 / @r;
      }
    }

    .logo {
      img {
        width: 91 / @r;
        height: 38 / @r;
        margin-left: 30 / @r;
      }
    }

    .link {
      display: none;
    }

    .copyright {
      font-size: 20 / @r;
      line-height: 40 / @r;
      margin-right: 30 / @r;
    }
  }
}
</style>